import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import {
    Theme,
    Tooltip,
    Typography
} from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const propTypes = {
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
    isRequired: PropTypes.bool
};

const defaultProps = {
    tooltip: null,
    isRequired: false
}

interface InputLabelProps {
    label: string;
    tooltip?: string;
    isRequired?: boolean;
}

function InputLabel ({ label, tooltip, isRequired }: InputLabelProps) {
    const classes = useStyles();

    return (
        <Typography classes={{ root: classes.root }} color="textPrimary">
            {label}
            {
                Boolean(tooltip) &&
                    <Tooltip
                        arrow
                        title={tooltip ?? ''}
                        placement="right"
                    >
                        <InfoOutlinedIcon />
                    </Tooltip>
            }
            {
                Boolean(isRequired) &&
                <Typography
                    classes={{ root: classes.isRequired }}
                    component="span"
                    variant="caption"
                    color="textSecondary"
                >
                    is required
                </Typography>
            }
        </Typography>
    );
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexShrink: 0,
        width: '150px',
        display: 'flex',
        alignItems: 'center',
        // alignSelf & marginTop used to handle multiline autocomplete otherwise better to leave out
        // alignSelf: 'flex-start',
        // marginTop: 7.5,
        '&> svg': {
            fontSize: '1em',
            marginLeft: '6px'
        },
        position: 'relative'
    },
    isRequired: {
        position: 'absolute',
        // ...theme.typography.caption,
        color: theme.palette.primary.light,
        marginRight: 'auto',
        textTransform: 'initial',
        top: 16
    }
}));

InputLabel.propTypes = propTypes;
InputLabel.defaultProps = defaultProps;

export default InputLabel;